import { useState } from "react";
import menuData from "../data/menuData";
import MenuItem from "./MenuItem";

function Menu({ addToCart }) {
  const [items, setItems] = useState(menuData);
  const [active, setActive] = useState("All");

  const filterItems = (category) => {
  setActive(category);

  if (category === "All") {
    setItems(menuData);
    return;
  }

  const filtered = menuData.filter(
    (item) => item.category === category
  );
  setItems(filtered);
  };

  

  return (
    <div className="menu" id="menu">
      <h2>Our Menu</h2>

      <div className="buttons">
        <button
          className={active === "All" ? "active" : ""}
          onClick={() => filterItems("All")}
        >
          All
        </button>
        <button
          className={active === "Pizza" ? "active" : ""}
          onClick={() => filterItems("Pizza")}
        >
          Pizza
        </button>
        <button
          className={active === "Burger" ? "active" : ""}
          onClick={() => filterItems("Burger")}
        >
          Burger
        </button>
        <button
          className={active === "Pasta" ? "active" : ""}
          onClick={() => filterItems("Pasta")}
        >
          Pasta
        </button>
        <button
          className={active === "Salad" ? "active" : ""}
          onClick={() => filterItems("Salad")}
        >
          Salad
        </button>
      </div>

      <div className="menu-list">
        {items.map((item) => (
          <MenuItem key={item.id} item={item} addToCart={addToCart} />
        ))}
      </div>
    </div>
  );
}

export default Menu;